import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    employeesTermination: [],
    totalItems:0,
    employeeTermination: {}
};

const getters = {
    index: state => employeeTerminationId => state.employeesTermination.findIndex(i => i.employeeTerminationId === employeeTerminationId)
};

const mutations = {
    setEmployeeSTermination: (state, r) => (state.employeesTermination = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    setEmployeeTermination: (state, r) => (state.employeeTermination = r),
    add: (state, r) => state.employeesTermination.unshift(r),
    edit: (state, { index, r }) => state.employeesTermination.splice(index, 1, r),
    delete: (state, index) => state.employeesTermination.splice(index, 1),
    approve: (state, index) => state.employeesTermination[index].status = status.active,
    reject: (state, index) => state.employeesTermination[index].status = status.rejected,
   
};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.employeesTermination.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployeeSTermination", response.data.employeesTermination);
            commit("setTotalItems", response.data.totalItems);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            let formdata = new FormData()
            formdata.append("employeeId", payload.employeeId)
            formdata.append("terminationTypeId", payload.terminationTypeId)
            formdata.append("terminationDate", payload.terminationDate)
            formdata.append("attachmentFile", payload.attachmentFile)
            formdata.append("remarks", payload.remarks)
            formdata.append("decisionNo", payload.decisionNo)


            startLoading()
            const response = await dataService.employeesTermination.add(formdata);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.employeeTermination);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeesTermination.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async approve({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeesTermination.approve(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("approve", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async reject({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeesTermination.reject(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("reject", index);
        } catch (error) {

            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setEmployeeTermination", {});
            startLoading()
            const response = await dataService.employeesTermination.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployeeTermination", response.data.employeeTermination);
         
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.employeesTermination.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.employeeTermination);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.employeesTermination.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
         
            const index = getters.index(id);
            commit("edit", { index, r: response.data.employeeTermination });

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },


};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
